export const HelpDeskEddy = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1304_8191)">
        <rect
          x="16"
          y="8"
          width="48"
          height="48"
          rx="12"
          fill="white"
          fillOpacity="0.5"
        />
        <rect
          x="16.5"
          y="8.5"
          width="47"
          height="47"
          rx="11.5"
          stroke="white"
        />
        <g clipPath="url(#clip0_1304_8191)">
          <path
            d="M38.3144 34.5178C38.8052 35.5968 39.7028 36.4362 40.81 36.8516C41.9173 37.2671 43.1437 37.2246 44.2198 36.7335C45.201 36.2905 45.9866 35.5023 46.4279 34.5178C46.5056 34.3828 46.5269 34.2224 46.487 34.0717C46.4471 33.921 46.3494 33.7923 46.2152 33.7137C46.0718 33.6229 45.8983 33.5927 45.7327 33.6298C45.5672 33.6669 45.423 33.7683 45.3317 33.9118L45.3155 33.9281C45.1652 34.2443 44.9785 34.5418 44.7592 34.8144C44.488 35.1093 44.1668 35.3537 43.8106 35.5363C43.1815 35.8516 42.4668 35.9517 41.7756 35.8213C41.0844 35.691 40.4547 35.3373 39.9826 34.8144C39.7613 34.5433 39.5744 34.2455 39.4264 33.9281C39.3838 33.8545 39.327 33.79 39.2594 33.7385C39.1918 33.687 39.1147 33.6495 39.0325 33.6282C38.9503 33.6068 38.8647 33.602 38.7807 33.614C38.6967 33.6261 38.6159 33.6548 38.543 33.6984L38.5267 33.7147C38.3928 33.7934 38.2954 33.922 38.2556 34.0724C38.2159 34.2228 38.237 34.3829 38.3144 34.5178ZM39.5078 22.5377C37.7488 23.2335 36.2857 24.5215 35.3694 26.1809L35.3368 26.263C35.3206 26.2957 35.3043 26.3126 35.2549 26.2957C32.572 24.95 29.3989 26.263 28.7933 29.2992C28.7933 29.3487 28.7771 29.3814 28.7771 29.4304C28.7714 29.5033 28.7431 29.5725 28.6962 29.6285C28.6493 29.6844 28.5861 29.7242 28.5155 29.7423C28.4335 29.775 28.3674 29.8082 28.2865 29.8413C26.9527 30.5193 25.9197 31.6729 25.3901 33.0756C24.8605 34.4783 24.8726 36.0289 25.4239 37.4232C25.8595 38.446 26.5743 39.3245 27.486 39.9575C28.3976 40.5905 29.4689 40.9522 30.5765 41.001H49.4702L50.2391 40.9683C51.5576 40.8473 52.7814 40.23 53.6646 39.2405C54.5477 38.251 55.0246 36.9627 54.9994 35.6348C55.028 34.958 54.9209 34.2822 54.6845 33.6476C54.4482 33.013 54.0874 32.4324 53.6234 31.9402C52.981 31.265 52.1836 30.7579 51.3008 30.4632C50.9806 30.3658 50.6519 30.2994 50.3191 30.2652C50.3537 29.2198 50.1871 28.1775 49.8285 27.1954C49.1486 25.3215 47.795 23.7703 46.0336 22.8462C45.0021 22.3086 43.859 22.0219 42.6967 22.0094C41.6082 21.9533 40.5205 22.1335 39.5078 22.5377ZM29.4809 30.7925C29.5596 30.7724 29.6363 30.7449 29.7099 30.7103C29.7904 30.6692 29.8612 30.6113 29.9177 30.5405C29.9741 30.4697 30.0148 30.3877 30.0371 30.2998C30.0534 30.2008 30.0534 30.0864 30.0697 29.9879C30.1842 28.9214 30.5114 27.9856 31.5582 27.4276C32.1394 27.1349 32.797 27.0311 33.4396 27.1305C33.9631 27.1817 34.4563 27.4004 34.8463 27.7544C35.0391 27.9223 35.2791 28.0261 35.5333 28.0514C35.646 28.055 35.7579 28.0325 35.8605 27.9856C36.1221 27.8544 36.1714 27.6885 36.2859 27.4439C36.9893 26.0491 37.7419 24.9331 39.0498 24.1761C40.228 23.5103 41.5798 23.2185 42.9267 23.3393C44.1048 23.4364 45.235 23.8503 46.1984 24.5375C46.9493 25.08 47.5797 25.7728 48.0499 26.5722C48.5202 27.3716 48.8199 28.2602 48.9302 29.1818C48.9465 29.8057 48.9628 30.4127 48.9628 31.0361C48.9787 31.1479 49.0304 31.2516 49.1101 31.3315C49.1897 31.4114 49.293 31.4632 49.4045 31.4792L49.6335 31.5119C50.0717 31.5376 50.5054 31.6147 50.9257 31.7416C51.7233 31.9824 52.4205 32.4785 52.9107 33.1541C53.4009 33.8298 53.6571 34.6478 53.6402 35.4833C53.6647 36.5203 53.2971 37.5282 52.6113 38.3045C51.9254 39.0808 50.9722 39.568 49.943 39.6681L48.8305 39.7008H34.0122L30.4951 39.6681C29.7277 39.6049 28.9877 39.3532 28.3401 38.9354C27.6925 38.5176 27.1573 37.9464 26.7816 37.2722C26.3688 36.4283 26.2369 35.4737 26.4055 34.549C26.4603 33.9068 26.6633 33.2862 26.9983 32.7363C27.3333 32.1863 27.7912 31.7221 28.3358 31.3802C28.6889 31.1319 29.0742 30.9332 29.4809 30.7895V30.7925Z"
            fill="#757576"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_dd_1304_8191"
          x="0"
          y="0"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="8" />
          <feGaussianBlur stdDeviation="8" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1304_8191"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1304_8191"
            result="effect2_dropShadow_1304_8191"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1304_8191"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_1304_8191">
          <rect
            width="30"
            height="19"
            fill="white"
            transform="translate(25 22)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
